import { render } from "./RatingBarRank11-2.vue?vue&type=template&id=38d00ddb&scoped=true"
const script = {}

import "./RatingBarRank11-2.vue?vue&type=style&index=0&id=38d00ddb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d00ddb"]])

export default __exports__